import axios from "../../axiosInstance";
import type { Badge, BadgeFilters } from "@/modules/learningCenter/features/BadgeManagement/types/badge.types";

export const fetchBadges = async (filters?: BadgeFilters): Promise<Badge[]> => {
  const params = new URLSearchParams();

  if (filters?.type) params.append("type", filters.type);
  if (filters?.active !== undefined) params.append("active", String(filters.active));
  if (filters?.pathId) params.append("path_id", filters.pathId);

  const response = await axios.get(`/api/badges?${params.toString()}`);

  // Transform snake_case response to camelCase
  const transformedBadges: Badge[] = response.data.badges.map((badge: any) => ({
    id: badge.id,
    name: badge.name,
    description: badge.description,
    iconType: badge.icon_type,
    iconValue: badge.icon_value,
    pointValue: badge.point_value,
    badgeType: badge.badge_type,
    isActive: badge.is_active,
    createdAt: badge.created_at,
    updatedAt: badge.updated_at,
    createdBy: badge.created_by,
    parentBadgeId: badge.parent_badge_id
  }));

  return transformedBadges;
};

export default fetchBadges;
